import { LitElement, html, css } from 'lit';
import {customElement, property, query} from 'lit/decorators.js'
import GridCSS from './styles/grid'
import '@shoelace-style/shoelace/dist/components/button/button'
import '@shoelace-style/shoelace/dist/components/tab/tab'
import '@shoelace-style/shoelace/dist/components/tab-group/tab-group'
import '@shoelace-style/shoelace/dist/components/tab-panel/tab-panel'
import './vxc_websrc_editor'
import './vxc_chatbot_kpi'
import './vxc_input'
import './vxc_select'
import './vxc_input_tags'
import './vxc_knowledge_base'
import './vxc_chatbot'
import { TInput } from './vxc_input';


@customElement('vxc-chatbot-demo')
class TChatBotDemo extends LitElement {
  static styles = [
    GridCSS,
    css`
        :host {
            width: 100%;
            height: 100%;
            background-color: #f6f9ff;
        }

        iframe {
            border: none;
            width: 100%;
            height: 100%;
            display: block;
        }
        `]

    @property({ type: String, attribute: 'app-uid'   })      uid : string = ''
    @property({ type: String, attribute: 'domain'   })       domain : string = ''

    private setDomain(event: CustomEvent) {
        const domain = event.detail
        console.log('set domain to', domain?.name, typeof domain?.name)
        if(domain?.name) {
            this.domain = (domain.name.startsWith('http'))? domain.name : `https://${domain.name}`  
        }
    }

    connectedCallback() {
        super.connectedCallback();
        if (!this.uid) {
            const pathParts = window.location.pathname.split('/').filter(Boolean)
            if (pathParts.length === 2 && pathParts[0] === 'chat') 
                this.uid = pathParts[1]
        }
    }

    render() {
        return html`
            <iframe src="${this.domain}"></iframe>
            <vxc-chatbot
                app=${this.uid}
                host="https://app.jinai.ai"
                data={}
                @domain=${this.setDomain}
            ></vxc-chatbot>
        `;
    }
}

declare global {
  interface HTMLElementTagNameMap {
    'vxc-chatbot-demo': TChatBotDemo;
  }
}